import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export class AssignSecurityServersActionValidator extends BaseNetworkActionValidator {
  protected requiresTasksEnabled = false;
  protected canRunForUnmanagedCompanies = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (record._id === Application.Main.user.company.id) {
      return false;
    }

    return record.type === Constants.Companies.TYPE_COMPANY || record.type === Constants.Companies.TYPE_COMPANY_FOLDER;
  }
}
